import { sortLicensesAccordingToPricing } from '../applications/common/helpers/pricingHelpers';

export function getPurchaseItemsForImage(itemWidth, itemHeight, shop) {
  const arrPurchaseItems = [];
  let index = 0;
  const { licenses, imageQualities, pricing } = shop;
  getQualitiesDataForLicensesFromGalleryPricing({
    itemWidth,
    itemHeight,
    licenses,
    imageQualities,
    galleryPricing: pricing,
    callback: (licenseId, arrSupportedQualitiesData) => {
      const license = licenses.find(licenseInfo => licenseInfo.licenseId === licenseId);
      arrSupportedQualitiesData.forEach(({
        qualityData,
        quality
      }) => {
        const itemIndex = index++;

        const purchaseItemData = {
          license,
          quality,
          qualityData,
          index: itemIndex,
        }
        arrPurchaseItems.push(purchaseItemData);
      });

    }
  });
  return arrPurchaseItems;
}

export function getQualitiesDataForLicensesFromGalleryPricing({
  itemWidth,
  itemHeight,
  licenses,
  imageQualities,
  galleryPricing,
  callback
}) {
  sortLicensesAccordingToPricing(licenses, galleryPricing).forEach(({ licenseId }) => {
    const licensePricingObject = galleryPricing[licenseId];
    if (licensePricingObject.enabled) {
      const arrAvailableLicenseQualities = [];
      imageQualities.forEach(quality => {
        const qualityPricingObject = licensePricingObject[quality.qualityId];
        if (typeof qualityPricingObject === 'object') {
          if (qualityPricingObject.isVisible) {
            arrAvailableLicenseQualities.push(Object.assign({}, quality, { price: qualityPricingObject.price, licenseId }));
          }
        }
      });
      const res = getQualityImageDataForLicenseQualities({
        itemWidth,
        itemHeight,
        arrQualities: arrAvailableLicenseQualities
      });

      callback(licenseId, res);
    }
  });
}

export function getQualityImageDataForLicenseQualities({ itemWidth, itemHeight, arrQualities }) {
  const arrData = [];

  if (arrQualities && Array.isArray(arrQualities)) {
    const imageLongPart = Math.max(itemWidth, itemHeight);
    let previousQuality = { maxPixelLength: 0 };

    arrQualities
      .sort((quality1, quality2) => {
        return quality1.maxPixelLength - quality2.maxPixelLength;
      })
      .forEach(quality => {
        const isBiggerThanLastQuality = imageLongPart > previousQuality.maxPixelLength;
        const isSmallerThanThisQuality = imageLongPart < quality.maxPixelLength;
        if ((isBiggerThanLastQuality && isSmallerThanThisQuality) || arrData.length === 0) {
          const qualityData = getQualityImageData({ itemWidth, itemHeight, quality });
          arrData.push({ qualityData, quality });
        }
        previousQuality = quality;
      });
  }

  return arrData;
}

export function getQualityImageData({ itemWidth, itemHeight, quality }) {
  const {
    dpi,
    maxPixelLength,
    allowFullRes
  } = quality;
  const imageLongPart = Math.max(itemWidth, itemHeight);
  let calculatedImageWidth = itemWidth;
  let calculatedImageHeight = itemHeight;
  let returnData = null;
  if ((imageLongPart >= maxPixelLength) && !allowFullRes) {
    if (itemWidth > itemHeight) {
      calculatedImageWidth = maxPixelLength;
      calculatedImageHeight = (itemHeight / itemWidth) * maxPixelLength;
    } else {
      calculatedImageHeight = maxPixelLength;
      calculatedImageWidth = (itemWidth / itemHeight) * maxPixelLength;
    }
  }

  calculatedImageHeight = Math.floor(calculatedImageHeight);
  calculatedImageWidth = Math.floor(calculatedImageWidth);

  const imageHeightInch = Math.floor((calculatedImageHeight / dpi) * 10) / 10;
  const imageWidthInch = Math.floor((calculatedImageWidth / dpi) * 10) / 10;

  returnData = {
    itemWidth,
    itemHeight,
    calculatedImageWidth,
    calculatedImageHeight,
    dpi,
    imageHeightInch,
    imageWidthInch
  };

  return returnData;
}

export function qualityDataToString(qualityData) {
  return `${qualityData.calculatedImageWidth}px x ${qualityData.calculatedImageHeight}px / ${qualityData.imageWidthInch} x ${qualityData.imageHeightInch}" @${qualityData.dpi}dpi`;
}

export function getQualityImageDataString({ itemWidth, itemHeight, quality }) {
  const qualityData = getQualityImageData({ itemWidth, itemHeight, quality });
  if (qualityData) {
    return qualityDataToString(qualityData);
  } else {
    return null;
  }
}
